import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from '@environments/environment';
import { SaveTechnologyTemplate } from '@app/model/saveTechnologyTemplate';
import { saveTechnologyTemplateSerializer } from '../model/serializer/saveTechnologyTemplateSerializer';

@Injectable({
  providedIn: 'root'
})
export class SaveTechnologyTemplateService extends ApiService<SaveTechnologyTemplate>{

    constructor(httpClient: HttpClient) {
      super(httpClient,
        environment.apiUrl,
        'interview/save-evaluation-feedback',
        new saveTechnologyTemplateSerializer());
     }
  }